/**
 * Who issues their own tax invoice.
 *
 * A licensed dealer (Type 3), an auction house (Type 4) and a tender seller (Type 5)
 * raise their own tax invoice and never sign our Vehicle Purchase Agreement. Several
 * parts of the platform have to agree about that list: the status preconditions that
 * let such a deal reach Committed, and the workspace steps that are greyed out because
 * they exist only to produce and collect a signature. So the list lives here once.
 *
 * This is a question about the workflow, not about GST. `gstTreatment.ts` keeps its own
 * list for a different question - is this seller registered, and what credit arises -
 * and the two happen to have the same members today. Changing one is not automatically
 * a reason to change the other.
 */
export const SELLER_TYPES_ISSUING_OWN_INVOICE = ['dealer', 'auction', 'tender'] as const

export type SellerTypeIssuingOwnInvoice = (typeof SELLER_TYPES_ISSUING_OWN_INVOICE)[number]

/** Case-insensitive, and safe on null: an unknown seller type is not one of these. */
export function sellerIssuesOwnInvoice(sellerType?: string | null): boolean {
  const t = String(sellerType || '').toLowerCase()
  return (SELLER_TYPES_ISSUING_OWN_INVOICE as readonly string[]).includes(t)
}
